import { render, staticRenderFns } from "./NotasEditar.vue?vue&type=template&id=a70677ca"
import script from "./NotasEditar.vue?vue&type=script&lang=js"
export * from "./NotasEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports